import Vue from "vue";
import Vuex from "vuex";
import persistedState from "vuex-persistedstate";
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [persistedState({ storage: window.localStorage })],
  state: {
    courseInfo: {},
    courseId: "",
    constructionId: "",
    courseName: "",
    userInfo: {}, //用户信息
    schoolPermission: [], //用户学校管理权限菜单
    courseType: "", //课程类型   GZ-高职 ZZ-中职
    zzMajorTree: [], //中职专业树
    gzMajorTree: [], //高职专业树
    zzMajorClassInfor: [], //中职课程专业大类
    gzMajorClassInfor: [], //高职课程专业大类
    majorClassId: "", //选择的专业大类id
    majorClassName: "", //选择的专业大类名称
    majorId: "", //选择的专业id
    courseDetailId: "", //跳转课程详情页时的课程id
    comments: [], //一条讨论的所有评论列表
    discussId: "", //获取一条讨论的评论列表的讨论id
    commentListShow: false, //评论列表展示与否
    examinationId: "", // 考试id
    isCanAudit: true, //是否可以提交审核
    teachGroupType: "", //教师类型    '课程负责人'---'主讲教师'
    auditState: null, //学校管理---开课管理---审核状态
    errorTime: false, //账号密码登录错误
    captchaShow: false,
    catalogInfo: {
      //授课选择的目录
      info: {},
      resInfo: "",
    },
    teachingMaterialList: [], //教学素材是否发放学生
    discussTitle: "",
    discussType: "",
    loginType: 2,
  },
  mutations: {
    courseName(state, courseName) {
      state.courseName = courseName;
    },
    captchaShow(state, captchaShow) {
      state.captchaShow = captchaShow;
    },
    errorTime(state, errorTime) {
      state.errorTime = errorTime;
    },
    auditState(state, auditState) {
      state.auditState = auditState;
    },
    teachGroupType(state, teachGroupType) {
      state.teachGroupType = teachGroupType;
    },
    isCanAudit(state, isCanAudit) {
      state.isCanAudit = isCanAudit;
    },
    changuserInfo(state, avatar) {
      state.userInfo.avatar = avatar;
    },
    commentListShow(state, commentListShow) {
      state.commentListShow = commentListShow;
    },
    discussId(state, discussId) {
      state.discussId = discussId;
    },
    comments(state, comments) {
      state.comments = comments;
    },
    courseInfo(state, courseInfo) {
      state.courseInfo = courseInfo;
    },
    courseId(state, id) {
      state.courseId = id;
    },
    constructionId(state, constructionId) {
      state.constructionId = constructionId;
    },
    userInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    schoolPermission(state, schoolPermission) {
      state.schoolPermission = schoolPermission;
    },
    courseType(state, courseType) {
      state.courseType = courseType;
    },
    zzMajorTree(state, zzMajorTree) {
      state.zzMajorTree = zzMajorTree;
    },
    gzMajorTree(state, gzMajorTree) {
      state.gzMajorTree = gzMajorTree;
    },
    zzMajorClassInfor(state, zzMajorClassInfor) {
      state.zzMajorClassInfor = zzMajorClassInfor;
    },
    gzMajorClassInfor(state, gzMajorClassInfor) {
      state.gzMajorClassInfor = gzMajorClassInfor;
    },
    majorClassId(state, majorClassId) {
      state.majorClassId = majorClassId;
    },
    majorClassName(state, majorClassName) {
      state.majorClassName = majorClassName;
    },
    majorId(state, majorId) {
      state.majorId = majorId;
    },
    courseDetailId(state, courseDetailId) {
      state.courseDetailId = courseDetailId;
    },
    addComment(state, data) {
      state.comments.forEach((item) => {
        if (item.id == data.id) {
          item = data;
        }
      });
    },
    // 考试id
    examinationId(state, id) {
      state.examinationId = id;
    },
    catalogInfo(state, info, resInfo) {
      state.info = info;
      state.resInfo = resInfo;
    },
    teachingMaterialList(state, teachingMaterialList) {
      state.teachingMaterialList = teachingMaterialList;
    },
    discussTitle(state, discussTitle) {
      state.discussTitle = discussTitle;
    },

    discussType(state, discussType) {
      state.discussType = discussType;
    },
    loginType(state, loginType) {
      state.loginType = loginType;
    },
  },
  actions: {},
  modules: {},
});
